import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FirebaseService } from 'src/app/service/firebase.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { finalize } from 'rxjs/operators';
import { ImageService } from 'src/app/service/image.service';

import { HostListener } from '@angular/core';

@Component({
  selector: 'app-adminland',
  templateUrl: './adminland.component.html',
  styleUrls: ['./adminland.component.scss']
})
export class AdminlandComponent implements OnInit {

  @Output() isLogout = new EventEmitter<void>()

  constructor(public firebaseService: FirebaseService, private storage: AngularFireStorage, private service: ImageService) { }

  img: string = "";
  selectedImg: any;
  isSubmit: boolean = false;
  
  formTemp = new FormGroup({
    
    title: new FormControl('', Validators.required),
    category: new FormControl(''),
    descrip: new FormControl('', Validators.required),
    imageUrl: new FormControl('', Validators.required),

  })
  imageList: any = [];
  rowIndex: any = [];
  messages: any = [];
  ngOnInit(): void {
    //this.resetForm();

    // this.getImageList();
    this.service.getImageDetails().subscribe((data: any) => {
      this.imageList = data.map((d: any) => {
        return {
          id: d.payload.doc.id,
          ...d.payload.doc.data()
        }
      });
      console.log(this.imageList);
    });

     
    if (this.up == true) {
      document.getElementById("remove")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("messages")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("upload")!.style.color = "rgb(255, 146, 5)"; 
    }

    //Get all the messages
    this.firebaseService.getMessage().subscribe((data:any) => {
      this.messages = data.map((e:any) => {
        return {
          id: e.payload.doc.id,
          ...e.payload.doc.data()
        } 
        
      })
      console.log(this.messages);
    });
    
    
  }

  path: string = "";

  upload($event: any) {
    this.path = $event.target.files[0];
  }

  uploadImage() {
    console.log(this.path);

    this.storage.upload("/files" + Math.random() + this.path, this.path);
  }

  showImg:boolean=false;
  showPreview(event: any) {
  
    if (event.target.files && event.target.files[0]) {
      this.showImg = true;
      const reader = new FileReader();
      reader.onload = (e: any) => this.img = e.target.result;
      reader.readAsDataURL(event.target.files[0]);
      this.selectedImg = event.target.files[0];


    } else {
      this.showImg = false;
      this.img = "/assets/Image/cam.jpg";
      this.selectedImg = null;
    }
  }

  onSubmiting(formValues: any) {
    this.isSubmit = true;
    console.log(formValues);
    var filePath = `${formValues.category}/${this.selectedImg.name.split('.').slice(0, -1).join('.')}_${new Date().getTime()}`;

    const fileRef = this.storage.ref(filePath);

    this.storage.upload(filePath, this.selectedImg).snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe((url) => {
          formValues['imgUrl'] = url;

          this.service.insertImageDetails(formValues);
          //this.service.insertImageDetails(formValues);

          this.resetForm();

        })
      })
    ).subscribe();



  }

  get formControls() {
    return this.formTemp['controls'];
  }

  resetForm() {
    this.formTemp.reset();
    this.formTemp.setValue({
      //caption:'',
      title: '',
      category: 'Attraction',
      descrip: '',
      imageUrl: '',
    });

    this.img = "/assets/Image/cam.jpg";
    this.selectedImg = null;
    this.isSubmit = false;
  }

  //Delete Image
  rem: boolean = false;
  up: boolean = true;
  view: boolean = false;
  user: any = [];
  id: any;
  remove(id: any) {
    //location.reload();
    this.service.deleteAdventure(id);
  }

  removeBtn(){
    this.rem = true;
    this.up = false;
    this.view = false;

    if (this.rem == true) {
      document.getElementById("upload")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("messages")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("remove")!.style.color = "rgb(255, 146, 5)"; 
    }
  }
  uploadBtn(){
    this.rem = false;
    this.up=true
    this.view = false;
    
    if (this.up == true) {
      document.getElementById("remove")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("messages")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("upload")!.style.color = "rgb(255, 146, 5)"; 
    }
  }

  viewBtn(){
    this.rem = false;
    this.up=false;
    this.view = true;
    
    if (this.view == true) {
      document.getElementById("remove")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("messages")!.style.color = "rgb(255, 146, 5)";
      document.getElementById("upload")!.style.color = "rgb(59, 58, 58)"; 
    }
  }

  //Remove a message
  removeMessage(id:any){
    this.firebaseService.deleteMessage(id);
  }

  @HostListener("window:scroll", []) onWindowScroll() {
    this.scrollFunction();
  }
  // When the user scrolls down 20px from the top of the document, show the button
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("myBtn")!.style.display = "block";
    } else {
      document.getElementById("myBtn")!.style.display = "none";
    }
  }

  // When the user clicks on the button, scroll to the top of the document
  topFunction() {
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' })
  }

  logout() {
    this.firebaseService.logout();
    this.isLogout.emit();
    location.reload();
  }
}
